interface Props {
  className?: string;
}

/** Fathom mark, used as the leading icon for all Fathom variables. */
export const FathomIcon = ({ className }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 14 14"
    fill="none"
    className={className}
    aria-hidden="true"
  >
    <path
      d="M3.91406 10.4149V10.9198C3.91406 11.4294 3.4535 11.8372 2.91016 11.7333L2.80078 11.705C2.47793 11.6035 2.25019 11.2912 2.25 10.9325V9.58093L3.91406 10.4149Z"
      fill="#88819F"
      stroke="#88819F"
    />
    <path
      d="M10.9241 8.32384C10.724 8.32384 10.5211 8.27869 10.33 8.18335L2.51419 4.28512C1.86708 3.96235 1.56615 3.1844 1.86739 2.52763C2.1826 1.8403 3.00223 1.55554 3.67392 1.89059L11.4885 5.7883C12.1443 6.11537 12.444 6.93364 12.1163 7.58831C11.883 8.0543 11.4126 8.32384 10.9241 8.32384Z"
      fill="#88819F"
    />
    <path
      d="M7.00088 10.2934C6.80086 10.2934 6.59789 10.2483 6.40679 10.1529L2.51423 8.21149C1.86712 7.88872 1.56619 7.11088 1.86733 6.4541C2.18254 5.76677 3.00217 5.48191 3.67396 5.81696L7.56547 7.75789C8.22119 8.08496 8.52097 8.90323 8.19326 9.5579C7.95995 10.0239 7.48955 10.2934 7.00099 10.2934H7.00088Z"
      fill="#88819F"
    />
  </svg>
);
